import apiClient from './client'
import API from '@/api/API'
import { NoteResponse, CreateNoteRequest, UpdateNoteRequest } from '@/lib/types/api'

export const notesApi = {
  list: async (params?: { notebook_id?: string }) => {
    const response = await apiClient.get<NoteResponse[]>(API.notes.base, { params })
    return response.data
  },

  get: async (id: string) => {
    const response = await apiClient.get<NoteResponse>(`${API.notes.base}/${id}`)
    return response.data
  },

  create: async (data: CreateNoteRequest) => {
    const response = await apiClient.post<NoteResponse>(API.notes.base, data)
    return response.data
  },

  update: async (id: string, data: UpdateNoteRequest) => {
    const response = await apiClient.put<NoteResponse>(`${API.notes.base}/${id}`, data)
    return response.data
  },

  delete: async (id: string) => {
    await apiClient.delete(`${API.notes.base}/${id}`)
  }
}
